import { HTMLAttributes, ReactNode, memo } from 'react'

import { AcademyHighlight } from '../ui-kit/components/AcademyHighlight.component'

type ParagraphProps = HTMLAttributes<HTMLParagraphElement> & {
  children?: ReactNode
}

const MemoizedAcademyHighlight = memo(AcademyHighlight)

export const processTagsInParagraph = (props: ParagraphProps) => {
  const { children, ...rest } = props

  if (
    typeof children !== 'string' ||
    !children.includes('!@') ||
    !children.includes('@!')
  ) {
    return <p {...rest}>{children}</p>
  }

  const estimatedPartCount = countOccurrences(children, '!@') * 2 + 1
  const parts: ReactNode[] = new Array(estimatedPartCount)
  let partIndex = 0

  const remainingText = children
  let currentPosition = 0

  while (remainingText.indexOf('!@', currentPosition) !== -1) {
    const startTagIndex = remainingText.indexOf('!@', currentPosition)
    const endTagIndex = remainingText.indexOf('@!', startTagIndex + 2)

    if (endTagIndex === -1) break

    if (startTagIndex > currentPosition) {
      parts[partIndex++] = remainingText.substring(
        currentPosition,
        startTagIndex
      )
    }

    const tagContent = remainingText.substring(startTagIndex + 2, endTagIndex)
    parts[partIndex++] = (
      <MemoizedAcademyHighlight key={`highlight-${partIndex}`}>
        {tagContent}
      </MemoizedAcademyHighlight>
    )

    currentPosition = endTagIndex + 2
  }

  if (currentPosition < remainingText.length) {
    parts[partIndex++] = remainingText.substring(currentPosition)
  }

  return <p {...rest}>{parts.slice(0, partIndex)}</p>
}

function countOccurrences(str: string, subStr: string): number {
  let count = 0
  let position = 0

  while (true) {
    position = str.indexOf(subStr, position)
    if (position === -1) break

    count++
    position += subStr.length
  }

  return count
}
